import Vue from 'vue'
import _ from 'lodash'
import mixinAlerta from '@/mixins/alerta'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'
export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { BotonesCancelarGuardar },
  mixins: [mixinAlerta],
  props: {
    operacion: {
      type: String,
      default: 'alta',
      validator: function (value) {
        return ['alta', 'modif', 'lectura'].indexOf(value) !== -1
      }
    },
    permiso: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      default: function () {
        return {
          id: 0
        }
      }
    },
    titulo: {
      type: String
    },
    modeloApi: {
      type: Object,
      required: true
    },
    origen: {
      type: String,
      default: 'abm'
    }
  },
  data () {
    return {
      editando: false,
      cargando: true,
      guardando: false,
      montarMixin: true,
      soloLectura: this.operacion === 'lectura',
      itemSeleccionado: _.cloneDeep(this.item),
      info: {}
    }
  },
  mounted () {
    // if (this.itemSeleccionado && this.itemSeleccionado.id > 0) {
    if (this.montarMixin) {
      this.cargarInfo()
    }
  },
  methods: {
    puedo (operacion) {
      return this.$puedo(this.permiso + ':' + operacion)
    },
    puedoPermiso (permiso, operacion) {
      return this.$puedo(permiso + ':' + operacion)
    },
    cargarInfo () {
      let vm = this
      vm.cargando = false
    },
    editar () {
      this.editando = true
      this.soloLectura = false
    },
    puedoEditar () {
      return this.operacion !== 'alta' && !this.editando && this.puedo('modif')
    },
    guardar () {
      let vm = this
      vm.$validator.validate().then(valid => {
        if (valid) {
          vm.ocultarAlerta()
          vm.antesDeGuardar()
          vm.guardando = true

          vm.metodoGuardar(vm.itemSeleccionado).then(
            data => {
              vm.mostrarMensajeOk()
              vm.alGuardar(data)
              vm.$emit('alGuardar', data)
              vm.guardando = false
            },
            error => {
              vm.guardando = false
              if (error.type === 422) {
                vm.mostrarErroresEnCampos(error)
              } else {
                vm.mostrarError(error)
              }
            }
          )
        }
      })
    },
    alGuardar (item) {},
    antesDeGuardar () {},
    cerrar () {
      this.$validator.reset()
      this.$emit('alCerrar', null)
    },
    mostrarMensajeOk () {
      Vue.notify({
        group: 'general',
        type: 'success',
        text: 'Los datos se guardaron correctamente!'
      })
    },
    metodoGuardar (datos) {
      return this.modeloApi.guardar(datos)
    }
  }
}
